import { useParams } from "react-router-dom"
import Footer from "../../components/footer"
import Header from "../../components/header"
import Grid from '@material-ui/core/Grid';
import {MyContainer} from '../../components/common/MyContainer'
import React,{ useEffect, useState, useRef } from "react"
import {
    PageTitle,
    PageTitleLeft,
    CategoryName,
    PageTitleRight,
    NewsTitle,
    CreatedAt,
    NewsDescription,
    NewsBody,
    ContainerRight,
    ContainerLeft,
    BodyWrap,
    NewsContent,
    AuthorWrap,
    Author,
    CmtFormBg,
    CmtTotal,
} from './detailNewsElements'
import {TitleTimeHome, BorderLine} from '../home/homeElements'
import { useDispatch, useSelector } from "react-redux";
import { getSingleNews, updateLikes, updateComments, updateCommentLikes, updateReplies } from '../../store/reducer/newsSlice'
import moment from 'moment'
import ReactHtmlParser from 'react-html-parser'
import CategoryBox from "../../components/categoryBox"
import HighlightBox from "../../components/highlightBox"
import MostViewBox from '../../components/mostViewBox'
import NewsHotBox from "../../components/newsHotBox";
import StickyMenu from "./stickyMenu";
import CommentForm from "../../components/commentForm";
import CommentList from "./commentList";


const DetailNews = ({match}) => {
    const {id} = useParams()
    const time = useRef(null)
    const {currentNews, currentNewsLoading} = useSelector(state => state.news)
    const { user } = useSelector(state => state.user)  
    const dispatch = useDispatch()
    const {socket} = useSelector(state => state.user)
    const [cmtTotal, setCmtTotal] = useState(0)

    useEffect(() => {
        ;(async () => {
            await dispatch(getSingleNews(id))
        })()

    },[dispatch, id])

    useEffect(() => {
        let total = 0
        currentNews.comments?.forEach(cmt => cmt?.children ? total += 1+cmt?.children.length:total++)
        setCmtTotal(total)
    }, [currentNews])

    useEffect(() => {
        const date = new Date();
        const dowArr = ['Chủ nhật', 'Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7']

        time.current = {
            dow: dowArr[date.getDay()],
            day: date.getDate(),
            month: date.getMonth()+1,
            year: date.getFullYear()
        }
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [match.url])

    useEffect(() => {
        if(currentNews._id) {
            socket.emit('joinRoom', currentNews._id)
        }
    }, [id, socket, currentNews._id, user])

    useEffect(() => {
        socket.on('sendNewsLikeUpdate', likes => dispatch(updateLikes(likes)))

   	 return () => socket.off('sendNewsLikeUpdate')
    }, [socket, dispatch])

    //update comment, reply
    useEffect(() => {
        socket.on('sendCommentToClient', comment => {
            if(comment.parentId) {
                dispatch(updateReplies(comment.parentId))

            }
            dispatch(updateComments(comment))
        })

        return () => socket.off('sendCommentToClient')
    }, [dispatch, socket])
    //update comment likes
    useEffect(() => {
        socket.on('sendComentLikes', comment => dispatch(updateCommentLikes(comment)))

        return () => socket.off('sendNewsLikeUpdate')
    }, [dispatch, socket])

    return (
        <>
            <Header />
                <MyContainer>
                    <PageTitle>
                        <PageTitleLeft>
                            {!currentNewsLoading && <CategoryName title={currentNews.category} to='/'>{currentNews.category}</CategoryName>}
                        </PageTitleLeft>
                        <PageTitleRight>
                            {time.current && <TitleTimeHome style={{margin: '0'}}>{`${time.current.dow}, ngày ${time.current.day} tháng ${time.current.month} năm ${time.current.year}`}</TitleTimeHome>}
                        </PageTitleRight>
                    </PageTitle>
                    <BorderLine />
                    <Grid container>
                        <Grid item sm={12} md={8}>
                            {!currentNewsLoading &&
                                <ContainerLeft>
                                <NewsTitle>{currentNews.title}</NewsTitle>
                                <CreatedAt>{moment(currentNews.createdAt).format('DD/MM/yyyy HH:mm:ss')}</CreatedAt>
                                <BodyWrap>
                                    <StickyMenu news={currentNews} />
                                    <NewsContent>
                                        <NewsDescription>{currentNews.description}</NewsDescription>
                                        <NewsBody>{ReactHtmlParser(currentNews.body)}</NewsBody>
                                    </NewsContent>
                                </BodyWrap>
                                <AuthorWrap>
                                    Tác giả: <Author>{currentNews.author}</Author>
                                </AuthorWrap>
                                <BorderLine style={{marginBottom: '10px'}} />
                                <CmtFormBg id="cmtBox">
                                    <CommentForm newsId={currentNews._id} />
                                </CmtFormBg>
                                <CmtTotal>Bình luận ({cmtTotal})</CmtTotal>
                                <CommentList newsId={currentNews._id} comments={currentNews.comments} />
                            </ContainerLeft>
                            }
                        </Grid>
                        <Grid sm={12} item md={4}>
                            <ContainerRight>
                                <iframe className='hide-on-mobile-tablet' title="unique" id="adviewIf9443" src="https://ads.novanet.vn/Ad?ssl=true&amp;v=1625896660739&amp;ssl=true&amp;zone=9443&amp;url=https%3A%2F%2Fcongnghe%2Etuoitre%2Evn%2Fqualcomm-trinh-lang-dien-thoai-sieu-sang-gia-1-500-usd-20210709101733894%2Ehtm&amp;host=congnghe%2Etuoitre%2Evn&amp;ref=&amp;hl=3&amp;br=3&amp;brver=91&amp;osname=1&amp;osver=0&amp;width=300&amp;height=600&amp;time=739&amp;h5e=true&amp;nnc=null&amp;cenable=true&amp;newnnc=false" scrolling="no" frameBorder="0" allowtransparency="true" style={{marginTop: '20px', padding: '0'}} width="300" height="600"></iframe>
                                <NewsHotBox category={currentNews.category} type='view' />
                                <iframe className='hide-on-mobile-tablet' title="1" src="https://cdnstoremedia.com/adt/banners/nam2015/4043/min_html5/anhnguyendoanle/2021_07_09/300x250_T7_40/300x250_T7_40/300x250_T7_40.html?url=%2F%2Flg1.logging.admicro.vn%2Fadn%3Fdmn%3Dhttps%253A%252F%252Ftuoitre.vn%252F%26rid%3D1f47d453-ad58-42eb-9ec7-ee61847f35e5121-60e941c8%26ctr%3D0.489775906316936%26sspb%3D2448%26sspr%3D0.001%26lsn%3D1625899455988%26ce%3D1%26lc%3D5%26cr%3D1625027409%26ui%3D2750274091907117133%26uuid%3De401684dc22bea82907ffa77362a622f%26bi%3D0%26cmpg%3D59304%26items%3D246709%26zid%3D474295%26pr%3D24734624385%26cid%3D-1%26tp%3D11%26tpn%3D4%26alg%3D10%26sspz%3D1543%26adc_cpa%3D1%26cov%3D1%26re%3Dhttps%253A%252F%252Ffptshop.com.vn%252F%253Futm_source%253Dadmicro%2526utm_medium%253DADX%2526utm_campaign%253D9ngayvang&amp;admid=adnzone_474295_0_246709&amp;vast=https%3A%2F%2Fsspapi.admicro.vn%2Fssp_request%2Fvideo%3Fu%3Dtuoitre.vn%252F%26z%3D474295%26p%3D1%26w%3D650%26h%3D300%26%26lsn%3D8a656b850f984b311bd48c10c9bc5900%26dgid%3D636b779a771444eb535cad65c0c6cdf4%26l%3D5%26loc%3D5%26i%3D2750274091907117133%26isdetail%3D0%26pid%3D%26tags%3D5%26adstype%3D%26vtype%3D8%26vid%3D%26bannerid%3D246709" width="300" height="250" frameBorder="0" scrolling="no"></iframe>
                                <NewsHotBox category={currentNews.category} type='same' sticky />
                            </ContainerRight>
                        </Grid>
                    </Grid>
                    <MostViewBox />
                    <HighlightBox />
                    <CategoryBox ct1='thời sự' ct2='thế giới' rowfirst />
                    <CategoryBox ct1='pháp luật' ct2='kinh doanh' />
                    <CategoryBox ct1='nhịp sống trẻ' ct2='thể thao' rowfirst />
                    <CategoryBox ct1='văn hóa' ct2='giải trí' />
                    <CategoryBox ct1='giáo dục' ct2='công nghệ' rowfirst />
                    <CategoryBox ct1='khoa học' ct2='sức khỏe' />
                    <CategoryBox ct1='giả-thật' ct2='bạn đọc' rowfirst />
                    <CategoryBox ct1='du lịch' ct2='kinh doanh' />
                </MyContainer>
            <Footer />
        </>
    )
}

export default DetailNews
